import { CaseInfo, CaseStatus, OpportunityComplete } from '../../dto/model';

/**
 * Builds an {@link OpportunityComplete} payload from a {@link CaseInfo}.
 *
 * Shared between the online booking page (agent-driven completions) and the
 * autodialer flow (auto-completing a leftover assignment as NotReached). Pass
 * `opportunityComments` explicitly so callers without a comment input can omit it.
 */
export const buildCaseComplete = (
  info: CaseInfo,
  overrides: Partial<OpportunityComplete>,
  opportunityComments = '',
): OpportunityComplete => ({
  id: info.internalId,
  opportunityId: info.opportunityId,
  globalCustomerId: info.globalCustomerId,
  caseId: info.caseId,
  signUpId: info.signupId,
  customerLostReasons: null,
  customerLostDescription: null,
  opportunityComments,
  doNotCallBefore: null,
  caseStatus: CaseStatus.Booked,
  mailbox: false,
  isDataDeletionRequested: false,
  wrongContactId: info.contactId,
  ...overrides,
});
